<section id="services" class="services-section py-5">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="services-header text-center animate-on-scroll mb-5">
          <span class="section-label d-block">{{ sectionData.label }}</span>
          <h2 class="services-title">{{ sectionData.title }}</h2>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div 
        class="col-lg-4 col-md-6 col-12" 
        *ngFor="let service of services; let i = index"
      >
        <div 
          class="service-card animate-on-scroll h-100" 
          [style.transition-delay]="(i * 0.2) + 's'"
          (click)="onServiceClick(service.id)"
        >
          <div class="service-image">
            <img 
              [src]="service.image" 
              [alt]="service.title"
              loading="lazy"
              class="img-fluid"
            />
            <div class="service-overlay d-flex align-items-center justify-content-center">
              <i class="service-icon" [class]="service.iconClass"></i>
            </div>
          </div>
          
          <div class="service-content p-4">
            <h3 class="service-title">{{ service.title }}</h3>
            <p class="service-description">{{ service.description }}</p>
            <button class="btn service-learn-more p-0" [attr.aria-label]="'Learn more about ' + service.title">
              Learn More →
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>